<template>
    <div class="basic-data account-profile">
        <div class="profile-title">
            <h1>我的账户</h1>
            <p>在这里，管理你的个人资料与账户信息。</p>
        </div>
        <el-form
            size="small"
            label-position="top"
            class="basic-data-form profile-grid"
            ref="basicDataForm"
            :model="form"
            :rules="rules"
        >
            <div class="profile-column">
                <section class="profile-card">
                    <header>
                        <span class="profile-icon"
                            ><img
                                src="@/assets/images/account/559e1.svg"
                                alt=""
                        /></span>
                        <div>
                            <h2>个人资料</h2>
                            <p>让我们更好地认识你</p>
                        </div>
                    </header>
                    <div class="profile-fields">
                        <el-form-item label="昵称" for="profile-nickname"
                            ><el-input id="profile-nickname" maxlength="11" v-model="form.nickname"
                        /></el-form-item>
                        <el-form-item label="生日" for="profile-born"
                            ><el-date-picker id="profile-born"
                                v-model="form.born"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :editable="false"
                                placeholder="选择生日"
                        /></el-form-item>
                        <el-form-item label="性别"
                            ><el-radio-group aria-label="性别" v-model="form.sex"
                                ><el-radio :label="0" border>女</el-radio
                                ><el-radio :label="1" border
                                    >男</el-radio
                                ></el-radio-group
                            ></el-form-item
                        >
                        <el-form-item label="所在城市"
                            ><area-cascader
                                v-model="form.city"
                                type="text"
                                :level="1"
                                :data="$pcaa"
                                placeholder="请选择地址"
                        /></el-form-item>
                        <el-form-item label="详细地址" for="profile-address" class="full-field"
                            ><el-input id="profile-address" v-model="form.address" maxlength="30"
                        /></el-form-item>
                    </div>
                </section>
                <section class="profile-card">
                    <header>
                        <span class="profile-icon"
                            ><img
                                src="@/assets/images/account/b48c0.svg"
                                alt=""
                        /></span>
                        <div>
                            <h2>联系方式</h2>
                            <p>用于日常沟通与服务联系</p>
                        </div>
                    </header>
                    <div class="contact-fields">
                        <el-form-item label="电子邮箱" for="profile-email" prop="email"
                            ><el-input id="profile-email"
                                v-model="form.email"
                                maxlength="64" /></el-form-item
                        ><el-form-item label="微信" for="profile-wechat"
                            ><el-input id="profile-wechat"
                                v-model="form.wechat"
                                maxlength="20" /></el-form-item
                        ><el-form-item label="QQ" for="profile-qq"
                            ><el-input id="profile-qq" v-model="form.qq" maxlength="20"
                        /></el-form-item>
                    </div>
                </section>
                <section class="profile-card invite-code-card">
                    <span class="profile-icon"
                        ><img src="@/assets/images/account/68907.svg" alt=""
                    /></span>
                    <div>
                        <p>我的邀请码</p>
                        <strong>{{ inviteCode || "暂未提供" }}</strong>
                    </div>
                    <div class="invite-code-actions">
                        <el-button
                            size="mini"
                            :disabled="!inviteCode"
                            @click="copyInviteCode"
                            ><img
                                src="@/assets/images/account/72dcb.svg"
                                alt=""
                            />复制邀请码</el-button
                        ><el-button
                            size="mini"
                            :disabled="!inviteCode"
                            @click="openInvitePoster"
                            ><img
                                src="@/assets/images/account/19df2.svg"
                                alt=""
                            />分享海报</el-button
                        >
                    </div>
                </section>
            </div>
            <div class="profile-column">
                <section class="profile-card certification-card">
                    <header>
                        <span class="profile-icon"
                            ><img
                                src="@/assets/images/account/efa29.svg"
                                alt=""
                        /></span>
                        <div>
                            <h2>账户认证</h2>
                            <p>你的身份认证信息</p>
                        </div>
                    </header>
                    <div class="certification-actions">
                        <div>
                            <span>实名认证</span
                            ><button
                                type="button"
                                class="verification-entry"
                                :class="verificationStatusClass"
                                :disabled="verificationLoading"
                                @click="openVerificationDialog"
                            >
                                <i :class="verificationStatusIcon"></i
                                ><span>{{ verificationStatusText }}</span>
                            </button>
                        </div>
                        <div>
                            <span>校园认证</span
                            ><button
                                type="button"
                                class="verification-entry campus-verification-entry"
                                :class="campusVerificationStatusClass"
                                :disabled="campusVerificationLoading"
                                @click="openCampusVerificationDialog"
                            >
                                <i :class="campusVerificationStatusIcon"></i
                                ><span>{{ campusVerificationStatusText }}</span>
                            </button>
                        </div>
                    </div>
                </section>
                <section class="profile-card receipt-card">
                    <header>
                        <span class="profile-icon"
                            ><img
                                src="@/assets/images/account/8a554.svg"
                                alt=""
                        /></span>
                        <div>
                            <h2>收款信息</h2>
                            <p>管理你的收款账户</p>
                        </div>
                    </header>
                    <div class="profile-fields">
                        <el-form-item label="微信账号" for="profile-a_wechat"
                            ><el-input id="profile-a_wechat"
                                :value="form.a_wechat"
                                readonly
                                placeholder="暂未提供" /></el-form-item
                        ><el-form-item label="支付宝账号" for="profile-a_alipay"
                            ><el-input id="profile-a_alipay"
                                :value="form.a_alipay"
                                readonly
                                placeholder="暂未提供"
                        /></el-form-item>
                        <h3 class="full-field">
                            <img
                                src="@/assets/images/account/94bab.svg"
                                alt=""
                            />银行卡
                        </h3>
                        <el-form-item label="户名" for="profile-a_name"
                            ><el-input id="profile-a_name"
                                :value="form.a_name"
                                readonly
                                placeholder="暂未提供" /></el-form-item
                        ><el-form-item label="开户行" for="profile-a_bank"
                            ><el-input id="profile-a_bank"
                                :value="form.a_bank"
                                readonly
                                placeholder="暂未提供" /></el-form-item
                        ><el-form-item label="卡号" for="profile-a_card" class="full-field"
                            ><el-input id="profile-a_card"
                                :value="form.a_card"
                                readonly
                                placeholder="暂未提供"
                        /></el-form-item>
                    </div>
                    <p class="receipt-note">
                        <img
                            src="@/assets/images/account/38ac9.svg"
                            alt=""
                        />现有收款信息仅供核对，本页不支持修改。
                    </p>
                </section>
            </div>
        </el-form>
        <div class="profile-actions">
            <el-button :disabled="savingProfile" @click="setForm(basic_data)"
                >取消</el-button
            ><el-button
                type="primary"
                :loading="savingProfile"
                @click="handleSubmit"
                >保存修改</el-button
            >
        </div>
                <el-dialog
            title="我的邀请海报"
            :visible.sync="posterDialogVisible"
            width="520px"
            top="10px"
            append-to-body>
            <div class="invite-poster-dialog-content">
                <img v-if="imageData" :src="imageData" alt="我的邀请海报">
                <div v-else-if="posterState === 'loading'" class="invite-poster-status">
                    <i class="el-icon-loading"></i>
                    <p>正在生成中，请稍候</p>
                </div>
                <el-empty
                    v-else-if="posterState === 'failed'"
                    description="海报生成失败，请重新加载">
                    <el-button type="warning" size="mini" @click="loadInvitePoster">重新加载</el-button>
                </el-empty>
                <el-empty
                    v-else-if="posterState === 'empty'"
                    description="暂无可用的邀请海报">
                </el-empty>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="posterDialogVisible = false">关闭</el-button>
                <el-button
                    v-if="imageData"
                    type="warning"
                    size="mini"
                    icon="el-icon-download"
                    @click="downloadInvitePoster">
                    下载海报
                </el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="修改实名认证申请"
            :visible.sync="modificationApplicationDialogVisible"
            width="580px"
            :close-on-click-modal="false"
            custom-class="real-name-modification-dialog"
            append-to-body>
            <el-form
                ref="modificationApplicationForm"
                :model="modificationApplicationForm"
                label-width="120px"
                label-position="left"
                size="small">
                <el-form-item label="修改原因">
                    <el-select v-model="modificationApplicationForm.reason" placeholder="请选择修改原因" class="modification-application-input">
                        <el-option v-for="reason in modificationReasons" :key="reason.value" :label="reason.label" :value="reason.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申请说明">
                    <el-input
                        v-model="modificationApplicationForm.description"
                        type="textarea"
                        :rows="5"
                        maxlength="200"
                        show-word-limit
                        placeholder="请说明修改原因（1–200 字）">
                    </el-input>
                </el-form-item>
            </el-form>
            <p class="modification-application-tip">申请待处理期间，当前实名认证和相关资格保持有效。</p>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="modificationApplicationDialogVisible = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submittingModificationApplication" @click="requestModificationRiskConfirmation">提交申请</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="修改实名认证申请风险确认"
            :visible.sync="modificationRiskDialogVisible"
            width="480px"
            :close-on-click-modal="false"
            custom-class="real-name-modification-risk-dialog"
            append-to-body>
            <p class="modification-risk-copy">提交后，当前实名认证和相关资格在待处理期间保持不变。仅在申请获批后，当前实名结果才会被撤销，你需要重新完成自动实名认证。</p>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="modificationRiskDialogVisible = false">返回修改</el-button>
                <el-button type="danger" size="small" :loading="submittingModificationApplication" @click="submitModificationApplication">确认提交</el-button>
            </span>
        </el-dialog>
        <el-drawer
            title="修改实名认证申请历史"
            :visible.sync="modificationHistoryDrawerVisible"
            direction="rtl"
            size="620px"
            append-to-body>
            <div v-loading="modificationApplicationsLoading" class="modification-history-drawer">
                <div v-if="modificationApplicationsError" class="verification-load-error">
                    <i class="el-icon-warning-outline"></i>
                    <div><p>{{ modificationApplicationsError }}</p><el-button type="primary" size="mini" @click="loadModificationApplications">重新加载</el-button></div>
                </div>
                <template v-else-if="modificationApplications.length">
                    <article v-for="application in modificationApplications" :key="application.id" class="modification-history-item">
                        <header><strong>{{ application.reasonLabel }}</strong><el-tag size="mini" :type="modificationStatusTagType(application.status)">{{ application.statusLabel }}</el-tag></header>
                        <p>{{ application.description }}</p>
                        <p v-if="application.status === 'PENDING'" class="modification-history-pending">将在提交后 72 小时内处理</p>
                        <p v-if="application.resolutionReason" class="modification-history-resolution">处理说明：{{ application.resolutionReason }}</p>
                        <p class="modification-history-time">提交时间：{{ application.submittedAt }}<span v-if="application.finishedAt">；结束时间：{{ application.finishedAt }}</span></p>
                        <el-button v-if="application.status === 'PENDING'" type="text" size="mini" :loading="withdrawingModificationApplicationId === application.id" @click="withdrawModificationApplication(application.id)">撤回申请</el-button>
                    </article>
                </template>
                <el-empty v-else description="暂无修改实名认证申请记录"></el-empty>
            </div>
        </el-drawer>
        <el-dialog
            :title="verificationDialogTitle"
            :visible.sync="verificationDialogVisible"
            width="680px"
            :close-on-click-modal="false"
            custom-class="real-name-verification-dialog"
            append-to-body
            @closed="handleVerificationDialogClosed">
            <div v-if="verificationLoadError" class="verification-load-error">
                <i class="el-icon-warning-outline"></i>
                <div>
                    <p>{{ verificationLoadError }}</p>
                    <el-button type="primary" size="mini" @click="retryVerificationLoad">重新加载</el-button>
                </div>
            </div>
            <div v-else-if="showVerificationForm" class="verification-application automatic-verification">
                <ol class="verification-steps" aria-label="实名认证步骤">
                    <li :class="{ active: verificationStep === 'UPLOAD', done: verificationStep !== 'UPLOAD' }"><span>1</span><strong>上传证件</strong></li>
                    <li :class="{ active: verificationStep === 'REVIEW', done: verificationStep === 'COMPLETE' }"><span>2</span><strong>核对授权</strong></li>
                    <li :class="{ active: verificationStep === 'COMPLETE' }"><span>3</span><strong>完成认证</strong></li>
                </ol>
                <template v-if="verificationStep === 'UPLOAD'">
                    <div class="verification-privacy-note"><i class="el-icon-lock"></i><span>仅上传身份证人像面用于本次自动核验，图片不会在本页保留。</span></div>
                    <el-upload ref="identityPortraitUploader" class="verification-upload portrait-upload" action="#" accept="image/*" :auto-upload="false" :show-file-list="false" :on-change="handleIdentityPortraitUpload">
                        <img v-if="verificationForm.portraitPreview" :src="verificationForm.portraitPreview" alt="身份证人像面预览" class="verification-upload-preview">
                        <div v-else class="verification-upload-empty"><i class="el-icon-upload"></i><span>上传身份证人像面</span></div>
                    </el-upload>
                    <el-button v-if="verificationForm.portraitPreview" type="text" size="mini" @click="clearIdentityPortrait">重新选择</el-button>
                    <p class="verification-upload-tip">仅支持图片文件，单张不超过 5 MiB。</p>
                </template>
                <template v-else-if="verificationStep === 'REVIEW'">
                    <div class="verification-result verification-status-approved"><i class="el-icon-circle-check"></i><div><strong>请核对识别结果</strong><p>仅展示脱敏身份信息。</p></div></div>
                    <div class="verification-summary"><div><span>姓名</span><strong>{{ verificationForm.recognition.realNameMasked }}</strong></div><div><span>身份证号</span><strong>{{ verificationForm.recognition.idCardMasked }}</strong></div></div>
                    <el-checkbox v-model="verificationForm.agreementAccepted" class="verification-agreement">我已阅读并同意已发布的实名认证授权说明</el-checkbox>
                </template>
                <template v-else>
                    <div class="verification-result verification-status-approved"><i class="el-icon-circle-check"></i><div><strong>实名认证已完成</strong><p>你的实名状态已同步更新。</p></div></div>
                </template>
            </div>
            <div v-else v-loading="verificationLoading" class="verification-status-panel real-name-verification-status-panel">
                <template v-if="verification.status === 'UNVERIFIED' && verificationStatusLoaded">
                    <div class="verification-unverified-hero">
                        <h2>完成认证，解锁更多服务</h2>
                        <p>仅需上传身份证人像面并确认授权，证件原图不会在个人中心展示。</p>
                    </div>
                    <div class="verification-unverified-benefits">
                        <div><strong>提升账号可信度</strong><span>让合作与交易更安心</span></div>
                        <div><strong>开启校园认证</strong><span>继续补充在校身份资料</span></div>
                        <div><strong>开启创作者中心</strong><span>让才华得以变现</span></div>
                    </div>
                    <div class="verification-unverified-steps" aria-label="实名认证步骤">
                        <span><b>1</b>上传证件</span><i></i><span><b>2</b>核对授权</span><i></i><span><b>3</b>完成认证</span>
                    </div>
                    <div class="verification-unverified-actions">
                        <p>上传身份证即可自动认证</p>
                        <el-button type="primary" @click="startVerificationApplication">开始实名认证</el-button>
                    </div>
                </template>
                <template v-else>
                    <div class="verification-result verification-status-hero" :class="verificationStatusClass">
                        <i v-if="verification.status === 'APPROVED'" class="el-icon-check verification-approved-icon"></i>
                        <i v-else :class="verificationStatusIcon"></i>
                        <div>
                            <strong>{{ verificationStatusText }}</strong>
                            <p>{{ verificationStatusDescription }}</p>
                        </div>
                    </div>
                    <div v-if="verification.status === 'APPROVED'" class="verification-summary verification-status-summary">
                        <div><span>姓名</span><strong>{{ verification.name }}</strong></div>
                        <div><span>身份证号</span><strong>{{ verification.maskedIdNumber }}</strong></div>
                        <div><span>认证时间</span><strong>{{ verification.reviewedAt }}</strong></div>
                    </div>
                    <div v-if="verification.status === 'APPROVED' && verificationStatusLoaded" class="real-name-modification-entry">
                        <div class="verification-modification-copy">
                            <p v-if="latestModificationApplication">最新申请：{{ latestModificationApplication.reasonLabel }}（{{ latestModificationApplication.statusLabel }}）</p>
                            <p v-else>需要更正实名信息？请先提交修改申请。</p>
                        </div>
                        <div class="verification-modification-actions">
                            <el-button size="mini" @click="openModificationHistoryDrawer">申请历史</el-button>
                            <el-button type="primary" size="mini" :disabled="hasPendingModificationApplication" @click="openModificationApplicationDialog">修改实名认证</el-button>
                        </div>
                        <p v-if="hasPendingModificationApplication">已有待处理申请，可在申请历史中撤回。</p>
                    </div>
                </template>
            </div>
            <span v-if="showVerificationForm" slot="footer" class="dialog-footer">
                <el-button size="small" @click="verificationDialogVisible = false">{{ verificationStep === 'COMPLETE' ? '关闭' : '取消' }}</el-button>
                <el-button
                    v-if="verificationStep === 'UPLOAD'"
                    type="primary"
                    size="small"
                    :loading="submittingVerification"
                    @click="recognizeIdentityPortrait">
                    开始识别
                </el-button>
                <el-button
                    v-else-if="verificationStep === 'REVIEW'"
                    type="primary"
                    size="small"
                    :loading="submittingVerification"
                    :disabled="!verificationForm.agreementAccepted"
                    @click="confirmVerification">
                    确认并完成认证
                </el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="campusVerificationDialogTitle"
            :visible.sync="campusVerificationDialogVisible"
            width="680px"
            :close-on-click-modal="false"
            append-to-body
            @closed="handleCampusVerificationDialogClosed">
            <div v-if="campusVerificationLoadError" class="verification-load-error">
                <i class="el-icon-warning-outline"></i>
                <div>
                    <p>{{ campusVerificationLoadError }}</p>
                    <el-button type="primary" size="mini" @click="retryCampusVerificationLoad">重新加载</el-button>
                </div>
            </div>
            <div v-else-if="showCampusVerificationForm" class="verification-application campus-verification-application">
                <div class="verification-privacy-note">
                    <i class="el-icon-lock"></i>
                    <span>校园认证需要学生证封面和个人信息页，仅用于审核；提交后不会在个人中心展示原始材料。</span>
                </div>
                <el-form
                    ref="campusVerificationForm"
                    :model="campusVerificationForm"
                    :rules="campusVerificationRules"
                    label-width="128px"
                    label-position="left"
                    size="small">
                    <el-form-item label="姓名 / Name">
                        <el-input :value="campusVerificationName" disabled></el-input>
                        <p class="campus-verification-field-tip">姓名由实名认证资料自动带入，不能修改。</p>
                    </el-form-item>
                    <el-form-item label="学校 / School" prop="schoolId">
                        <el-select
                            v-model="campusVerificationForm.schoolId"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            :remote-method="searchCampusSchools"
                            :loading="campusSchoolsLoading"
                            @focus="loadCampusSchools"
                            placeholder="请选择学校"
                            no-data-text="暂无可选的启用院校"
                            class="campus-verification-input">
                            <el-option
                                v-for="school in campusSchools"
                                :key="school.id"
                                :label="school.label"
                                :value="school.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="入学时间 / Enrollment" prop="enrollmentMonth">
                        <el-date-picker
                            v-model="campusVerificationForm.enrollmentMonth"
                            type="month"
                            value-format="yyyy-MM"
                            @change="validateCampusGraduationMonth"
                            placeholder="请选择入学年月"
                            :picker-options="campusEnrollmentMonthPickerOptions"
                            class="campus-verification-input">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="预计毕业 / Graduation" prop="expectedGraduationMonth">
                        <el-date-picker
                            v-model="campusVerificationForm.expectedGraduationMonth"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="请选择预计毕业年月"
                            :picker-options="campusExpectedGraduationMonthPickerOptions"
                            class="campus-verification-input">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="学生证材料 / Student ID" required>
                        <div class="verification-upload-list">
                            <div class="verification-upload-item">
                                <el-upload
                                    ref="studentCardCoverUploader"
                                    class="verification-upload"
                                    action="#"
                                    accept="image/jpeg,image/png"
                                    :auto-upload="false"
                                    :show-file-list="false"
                                    :on-change="handleStudentCardCoverUpload">
                                    <img
                                        v-if="campusVerificationForm.studentCardCoverPreview"
                                        :src="campusVerificationForm.studentCardCoverPreview"
                                        alt="学生证封面预览"
                                        class="verification-upload-preview">
                                    <div v-else class="verification-upload-empty">
                                        <i class="el-icon-upload"></i>
                                        <span>上传学生证封面</span>
                                    </div>
                                </el-upload>
                                <el-button
                                    v-if="campusVerificationForm.studentCardCoverPreview"
                                    type="text"
                                    size="mini"
                                    @click="clearStudentCardImage('cover')">
                                    移除图片
                                </el-button>
                                <div class="verification-upload-label">封面</div>
                                <el-form-item prop="studentCardCover" class="verification-upload-validation"></el-form-item>
                            </div>
                            <div class="verification-upload-item">
                                <el-upload
                                    ref="studentCardProfileUploader"
                                    class="verification-upload"
                                    action="#"
                                    accept="image/jpeg,image/png"
                                    :auto-upload="false"
                                    :show-file-list="false"
                                    :on-change="handleStudentCardProfileUpload">
                                    <img
                                        v-if="campusVerificationForm.studentCardProfilePreview"
                                        :src="campusVerificationForm.studentCardProfilePreview"
                                        alt="学生证个人信息页预览"
                                        class="verification-upload-preview">
                                    <div v-else class="verification-upload-empty">
                                        <i class="el-icon-upload"></i>
                                        <span>上传个人信息页</span>
                                    </div>
                                </el-upload>
                                <el-button
                                    v-if="campusVerificationForm.studentCardProfilePreview"
                                    type="text"
                                    size="mini"
                                    @click="clearStudentCardImage('profile')">
                                    移除图片
                                </el-button>
                                <div class="verification-upload-label">个人信息页</div>
                                <el-form-item prop="studentCardProfile" class="verification-upload-validation"></el-form-item>
                            </div>
                        </div>
                        <p class="verification-upload-tip">仅支持 JPG、PNG 格式，单张图片不超过 5 MiB。</p>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else v-loading="campusVerificationLoading" class="verification-status-panel">
                <div class="verification-result" :class="campusVerificationStatusClass">
                    <i :class="campusVerificationStatusIcon"></i>
                    <div>
                        <strong>{{ campusVerificationStatusText }}</strong>
                        <p>{{ campusVerificationStatusDescription }}</p>
                    </div>
                </div>
                <div v-if="hasCampusCertificationDetails" class="verification-summary">
                    <div v-if="campusVerification.schoolName"><span>院校</span><strong>{{ campusVerification.schoolName }}</strong></div>
                    <div v-if="campusVerification.schoolLocation"><span>所在地区</span><strong>{{ campusVerification.schoolLocation }}</strong></div>
                    <div><span>入学年月</span><strong>{{ campusVerification.enrollmentMonth }}</strong></div>
                    <div><span>预计毕业</span><strong>{{ campusVerification.expectedGraduationMonth }}</strong></div>
                    <div><span>认证有效期</span><strong>{{ campusVerification.validUntil }}</strong></div>
                    <div><span>认证时间</span><strong>{{ campusVerification.reviewedAt }}</strong></div>
                </div>
                <div v-if="campusVerification.reason" class="verification-rejection">
                    <i class="el-icon-warning-outline"></i>
                    <span>{{ campusVerification.reason }}</span>
                </div>
                <div v-if="canCampusVerificationApply && campusVerification.status !== 'UNVERIFIED'" class="verification-resubmit-actions">
                    <el-button type="warning" size="small" @click="startCampusVerificationApplication">
                        {{ campusVerificationResubmissionLabel }}
                    </el-button>
                </div>
                <div class="verification-history">
                    <h4>认证记录</h4>
                    <div v-if="campusVerificationHistory.length" class="verification-history-list campus-verification-history-list">
                        <div v-for="record in campusVerificationHistory" :key="record.id" class="verification-history-item">
                            <div class="verification-history-time">{{ record.appliedAt }}</div>
                            <div>
                                <div class="verification-history-status-row">
                                    <span class="verification-history-status" :class="verificationStatusClassFor(record.status)">
                                        {{ campusVerificationStatusTextFor(record.status) }}
                                    </span>
                                    <el-button
                                        v-if="record.status === 'PENDING' && record.id === campusVerification.pendingApplicationId"
                                        class="verification-history-withdraw"
                                        type="text"
                                        size="mini"
                                        :loading="withdrawingCampusVerification"
                                        @click="withdrawCampusVerification">
                                        撤回申请
                                    </el-button>
                                </div>
                                <p>院校：{{ record.schoolName || "—" }}</p>
                                <p v-if="record.schoolLocation">所在地区：{{ record.schoolLocation }}</p>
                                <p>学籍时间：{{ record.enrollmentMonth }} 至 {{ record.expectedGraduationMonth }}</p>
                                <p>处理时间：{{ record.reviewedAt }}</p>
                                <p v-if="record.reason" class="verification-history-reason">处理说明：{{ record.reason }}</p>
                            </div>
                        </div>
                    </div>
                    <p v-else class="verification-history-empty">暂无认证申请记录。</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <template v-if="showCampusVerificationForm">
                    <el-button size="small" @click="campusVerificationDialogVisible = false">取消</el-button>
                    <el-button
                        type="primary"
                        size="small"
                        :disabled="hasCampusGraduationMonthError"
                        :loading="submittingCampusVerification"
                        @click="submitCampusVerification">
                        提交认证资料
                    </el-button>
                </template>
                <el-button v-else size="small" @click="campusVerificationDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
</div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import qs from 'qs';
import API from '@/tool/api';
import request from '@/tool/request';
import { getAvatarFileError } from '@/tool/avatarSubmission.cjs';
import {
    getResultData,
    getResultError,
    getResultMessage,
    isResultSuccess,
} from '@/tool/result';
import realNameCertification from '@/tool/realNameCertification.cjs';
import realNameModification from '@/tool/realNameModification.cjs';
import campusCertification from '@/tool/campusCertification.cjs';
import campusCertificationMonth from '@/tool/campusCertificationMonth.cjs';

const createEmptyVerificationForm = () => ({
    portraitFile: null,
    portraitPreview: "",
    agreementAccepted: false,
    recognition: {
        realNameMasked: "",
        idCardMasked: "",
        verificationToken: "",
    },
});

const createEmptyCampusVerificationForm = () => ({
    schoolId: "",
    enrollmentMonth: "",
    expectedGraduationMonth: "",
    studentCardCover: false,
    studentCardProfile: false,
    studentCardCoverFile: null,
    studentCardProfileFile: null,
    studentCardCoverPreview: "",
    studentCardProfilePreview: "",
});

const createEmptyModificationApplicationForm = () => ({
    reason: "",
    description: "",
});

export default {
    data(){
        return {
            API,
            savingProfile: false,
            requestEpoch: 0,
            form: {
                nickname: "",
                city: [],
                address: "",
                born: "",
                sex: "",
                phone: "",
                email: "",
                wechat: "",
                qq: "",
                a_wechat: "",
                a_alipay: "",
                a_name: "",
                a_card: "",
                a_bank: "",
            },
            posterDialogVisible: false,
            posterState: "idle",
            imageData: "",
            verificationDialogVisible: false,
            showVerificationForm: false,
            verificationLoading: false,
            verificationStatusLoaded: false,
            verificationLoadError: "",
            submittingVerification: false,
            verificationStep: "UPLOAD",
            verification: {
                status: "UNVERIFIED",
                name: "",
                maskedIdNumber: "",
                reviewedAt: "",
            },
            verificationForm: createEmptyVerificationForm(),
            modificationApplicationDialogVisible: false,
            modificationRiskDialogVisible: false,
            modificationHistoryDrawerVisible: false,
            modificationApplicationsLoading: false,
            modificationApplicationsError: "",
            submittingModificationApplication: false,
            withdrawingModificationApplicationId: null,
            modificationApplications: [],
            modificationApplicationForm: createEmptyModificationApplicationForm(),
            campusVerificationDialogVisible: false,
            showCampusVerificationForm: false,
            campusVerificationLoading: false,
            campusVerificationStatusLoaded: false,
            campusVerificationLoadError: "",
            submittingCampusVerification: false,
            withdrawingCampusVerification: false,
            campusVerification: {
                status: "UNVERIFIED",
            },
            campusVerificationHistory: [],
            campusSchools: [],
            campusSchoolsLoading: false,
            campusMonthBounds: campusCertificationMonth.getCampusMonthBounds(),
            campusVerificationForm: createEmptyCampusVerificationForm(),
            rules: {
                email: [{
                    type: "email",
                    message: "请输入正确的邮箱地址",
                    trigger: "blur",
                }],
            },
            campusVerificationRules: {
                schoolId: [{
                    required: true,
                    message: "请选择学校",
                    trigger: "change",
                }],
                enrollmentMonth: [{
                    required: true,
                    message: "请选择入学年月",
                    trigger: "change",
                }],
                expectedGraduationMonth: [{
                    required: true,
                    message: "请选择预计毕业年月",
                    trigger: "change",
                }, {
                    validator: (rule, value, callback) => this.validateExpectedGraduationMonth(value, callback),
                    trigger: "change",
                }],
                studentCardCover: [{
                    validator: (rule, value, callback) => {
                        callback(value ? undefined : new Error("请上传学生证封面"));
                    },
                    trigger: "change",
                }],
                studentCardProfile: [{
                    validator: (rule, value, callback) => {
                        callback(value ? undefined : new Error("请上传学生证个人信息页"));
                    },
                    trigger: "change",
                }],
            },
        }
    },
    computed: {
        ...mapState({
            basic_data: state => state.user.basic_data,
            basic_data_error: state => state.user.basic_data_error,
            user_id: state => state.user.user_id,
        }),
        inviteCode(){
            const code = this.basic_data && this.basic_data.inviteCode;
            return typeof code === "string" ? code.trim() : "";
        },
        verificationStatusText(){
            if (this.verificationLoading || !this.verificationStatusLoaded) {
                return this.verificationLoadError ? "加载失败" : "加载中";
            }
            return this.verificationStatusTextFor(this.verification.status);
        },
        verificationStatusIcon(){
            if (this.verificationLoading || !this.verificationStatusLoaded) {
                return this.verificationLoadError ? "el-icon-warning-outline" : "el-icon-loading";
            }
            const icons = {
                UNVERIFIED: "el-icon-postcard",
                APPROVED: "el-icon-circle-check",
            };
            return icons[this.verification.status] || icons.UNVERIFIED;
        },
        verificationStatusClass(){
            if (this.verificationLoadError) return "verification-status-rejected";
            return this.verificationStatusClassFor(this.verification.status);
        },
        verificationStatusDescription(){
            const descriptions = {
                APPROVED: "已完成实名认证，证件原图不会在个人中心展示。",
            };
            return descriptions[this.verification.status] || "尚未完成实名认证。";
        },
        verificationDialogTitle(){
            return this.showVerificationForm ? "自动实名认证" : "实名认证";
        },
        modificationReasons(){
            return realNameModification.MODIFICATION_REASONS;
        },
        latestModificationApplication(){
            return this.modificationApplications[0] || null;
        },
        hasPendingModificationApplication(){
            return this.modificationApplications.some((application) => application.status === "PENDING");
        },
        campusEnrollmentMonthPickerOptions(){
            return {
                disabledDate: (value) => campusCertificationMonth.isMonthOutsideRange(
                    value,
                    "0001-01",
                    this.campusMonthBounds.enrollmentMax,
                ),
            };
        },
        campusExpectedGraduationMonthPickerOptions(){
            return {
                disabledDate: (value) => campusCertificationMonth.isMonthOutsideRange(
                    value,
                    campusCertificationMonth.getExpectedGraduationMinimum(
                        this.campusVerificationForm.enrollmentMonth,
                        this.campusMonthBounds,
                    ),
                    this.campusMonthBounds.expectedGraduationMax,
                ),
            };
        },
        hasCampusGraduationMonthError(){
            const value = this.campusVerificationForm.expectedGraduationMonth;
            const enrollmentMonth = this.campusVerificationForm.enrollmentMonth;
            return !!value && (
                !!campusCertificationMonth.getExpectedGraduationMonthError(value, this.campusMonthBounds) ||
                !!enrollmentMonth && value < enrollmentMonth
            );
        },
        campusVerificationStatusText(){
            if (this.campusVerificationLoading || !this.campusVerificationStatusLoaded) {
                return this.campusVerificationLoadError ? "加载失败" : "加载中";
            }
            return this.campusVerificationStatusTextFor(this.campusVerification.status);
        },
        campusVerificationStatusIcon(){
            if (this.campusVerificationLoading || !this.campusVerificationStatusLoaded) {
                return this.campusVerificationLoadError ? "el-icon-warning-outline" : "el-icon-loading";
            }
            const icons = {
                UNVERIFIED: "el-icon-school",
                PENDING: "el-icon-time",
                APPROVED: "el-icon-circle-check",
                REJECTED: "el-icon-warning-outline",
                WITHDRAWN: "el-icon-remove-outline",
                EXPIRED: "el-icon-time",
                REVOKED: "el-icon-warning-outline",
                SUSPENDED: "el-icon-warning-outline",
            };
            return icons[this.campusVerification.status] || icons.UNVERIFIED;
        },
        campusVerificationStatusClass(){
            if (this.campusVerificationLoadError) return "verification-status-rejected";
            return `verification-status-${String(this.campusVerification.status || "UNVERIFIED").toLowerCase()}`;
        },
        campusVerificationStatusDescription(){
            if (this.campusVerification.status === "UNVERIFIED" && this.verificationStatusLoaded && this.verification.status !== "APPROVED") {
                return this.campusVerificationEligibilityMessage;
            }
            if (this.campusVerification.hasPendingApplication) {
                return "新的校园认证资料正在审核，当前认证记录及有效期仍可查看。";
            }
            const descriptions = {
                PENDING: "资料已提交，审核完成后会在这里显示结果。",
                APPROVED: "校园认证已完成",
                REJECTED: "本次申请未通过，请查看处理说明后重新提交。",
                WITHDRAWN: "本次申请已撤回，可重新提交校园认证资料。",
                EXPIRED: "校园认证已到期，可重新提交最新学籍资料。",
                REVOKED: "校园认证已被撤销，请查看处理说明。",
                SUSPENDED: "校园认证已暂停，请先确认实名认证状态后重新提交。",
            };
            return descriptions[this.campusVerification.status] || "填写校园认证资料后提交审核。";
        },
        campusVerificationDialogTitle(){
            return this.showCampusVerificationForm ? "校园认证" : "校园认证状态";
        },
        campusVerificationName(){
            return this.verification.name || "将由实名认证资料自动带入";
        },
        campusVerificationEligibilityMessage(){
            const messages = {
                PENDING: "实名认证资料正在审核，审核通过后才能提交校园认证。",
                REJECTED: "实名认证未通过，请先重新提交实名认证资料。",
                REVOKED: "实名认证已撤销，请先完成有效实名认证。",
            };
            return messages[this.verification.status] || "请先完成有效实名认证后再提交校园认证。";
        },
        canCampusVerificationApply(){
            return !this.campusVerification.pendingApplicationId &&
                ["UNVERIFIED", "REJECTED", "WITHDRAWN", "EXPIRED", "REVOKED", "SUSPENDED"].indexOf(this.campusVerification.status) !== -1;
        },
        hasCampusCertificationDetails(){
            return ["APPROVED", "EXPIRED", "REVOKED", "SUSPENDED"].indexOf(this.campusVerification.status) !== -1;
        },
        campusVerificationResubmissionLabel(){
            return this.campusVerification.status === "EXPIRED" ? "重新认证" : "重新提交";
        },
    },
    methods: {
        ...mapMutations([
            "setAvatar",
            "setBasicData"
        ]),
        ...mapActions([
            "getBasicData",
            "handleChangeBasic",
            "handleChangeAvatar"
        ]),
        handleRequest(val){
            const error = getAvatarFileError(val.file);
            if (error) {
                this.$message.error(error);
                return ;
            }
            this.submitAvatar(val.file);
        },
        submitAvatar(avatar){
            this.handleChangeAvatar(avatar).then((res) => {
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: res.type,
                });
            }).catch(() => {})
        },
        setForm(basic){
            this.form = {
                nickname: basic.nickname,
                city: [basic.province, basic.city, basic.area].filter(Boolean),
                address: basic.address,
                born: basic.born,
                sex: basic.sex,
                phone: basic.phone,
                email: basic.email,
                wechat: basic.wechat || "",
                qq: basic.qq || "",
                a_wechat: basic.aWechat || "",
                a_alipay: basic.aAlipay || "",
                a_name: basic.aName || "",
                a_card: basic.aCard || "",
                a_bank: basic.aBank || "",
            }
        },
        copyInviteCode(){
            const code = this.inviteCode;
            if (!code) return;
            const showCopied = () => this.$message.success("邀请码已复制");
            const showCopyFailure = () => this.$message.warning(`复制失败，请手动复制邀请码：${code}`);
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(code).then(showCopied).catch(showCopyFailure);
                return;
            }
            const input = document.createElement("textarea");
            input.value = code;
            input.setAttribute("readonly", "readonly");
            input.style.position = "fixed";
            input.style.opacity = "0";
            document.body.appendChild(input);
            input.select();
            try {
                const copied = document.execCommand("copy");
                (copied ? showCopied : showCopyFailure)();
            } catch (error) {
                showCopyFailure();
            } finally {
                document.body.removeChild(input);
            }
        },
        openInvitePoster(){
            if (!this.inviteCode) return;
            this.posterDialogVisible = true;
            this.loadInvitePoster();
        },
        loadInvitePoster(){
            this.posterState = "loading";
            this.imageData = "";

            request.get(API.user.invitePoster)
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        this.posterState = "failed";
                        return;
                    }
                    const data = getResultData(response) || {};
                    this.imageData = data.imageData || "";
                    if (!this.imageData) {
                        this.posterState = "empty";
                        return;
                    }
                    this.posterState = "ready";
                })
                .catch(() => {
                    this.posterState = "failed";
                });
        },
        downloadInvitePoster(){
            if (!this.imageData) return;
            const link = document.createElement("a");
            link.href = this.imageData;
            link.download = "ijust-invitation-poster";
            link.click();
        },
        verificationStatusTextFor(status){
            const texts = {
                UNVERIFIED: "未认证",
                APPROVED: "已认证",
            };
            return texts[status] || texts.UNVERIFIED;
        },
        verificationStatusClassFor(status){
            return `verification-status-${String(status || "UNVERIFIED").toLowerCase()}`;
        },
        openVerificationDialog(){
            this.showVerificationForm = false;
            this.verificationDialogVisible = true;
            this.loadVerification(true);
        },
        openModificationApplicationDialog(){
            if (this.verification.status !== "APPROVED") return;
            if (this.hasPendingModificationApplication) {
                this.$message.warning("已有待处理的修改实名认证申请，请在申请历史中查看或撤回。");
                return;
            }
            request.get(API.user.realNameModification.eligibility)
                .then((response) => {
                    if (!isResultSuccess(response)) throw getResultError(response, "修改实名认证资格校验失败");
                    this.modificationApplicationForm = createEmptyModificationApplicationForm();
                    this.modificationRiskDialogVisible = false;
                    this.modificationApplicationDialogVisible = true;
                }).catch((error) => {
                    this.$message.error(getResultMessage(error, "修改实名认证资格校验失败，请稍后重试"));
                });
        },
        openModificationHistoryDrawer(){
            if (this.verification.status !== "APPROVED") return;
            this.modificationHistoryDrawerVisible = true;
        },
        loadModificationApplications(){
            if (this.verification.status !== "APPROVED") {
                this.modificationApplications = [];
                return Promise.resolve(false);
            }
            this.modificationApplicationsLoading = true;
            this.modificationApplicationsError = "";
            return request.get(API.user.realNameModification.applications)
                .then((response) => {
                    if (!isResultSuccess(response)) throw getResultError(response, "修改实名认证申请历史加载失败");
                    this.modificationApplications = realNameModification.normalizeModificationApplications(getResultData(response));
                    return true;
                }).catch((error) => {
                    this.modificationApplicationsError = error.message || getResultMessage(error, "修改实名认证申请历史加载失败");
                    return false;
                }).finally(() => {
                    this.modificationApplicationsLoading = false;
                });
        },
        requestModificationRiskConfirmation(){
            const errorMessage = realNameModification.validateModificationApplication(this.modificationApplicationForm);
            if (errorMessage) {
                this.$message.error(errorMessage);
                return;
            }
            this.modificationRiskDialogVisible = true;
        },
        submitModificationApplication(){
            if (this.submittingModificationApplication) return;
            const errorMessage = realNameModification.validateModificationApplication(this.modificationApplicationForm);
            if (errorMessage) {
                this.modificationRiskDialogVisible = false;
                this.$message.error(errorMessage);
                return;
            }
            const payload = {
                reason: this.modificationApplicationForm.reason,
                description: this.modificationApplicationForm.description.trim(),
            };
            this.submittingModificationApplication = true;
            request.post(API.user.realNameModification.applications, qs.stringify(payload))
                .then((response) => {
                    if (!isResultSuccess(response)) throw getResultError(response, "修改实名认证申请提交失败");
                    this.modificationRiskDialogVisible = false;
                    this.modificationApplicationDialogVisible = false;
                    this.$message.success("修改实名认证申请已提交");
                    return this.loadModificationApplications();
                }).catch((error) => {
                    this.$message.error(getResultMessage(error, "修改实名认证申请提交失败，请稍后重试"));
                }).finally(() => {
                    this.submittingModificationApplication = false;
                });
        },
        withdrawModificationApplication(applicationId){
            if (this.withdrawingModificationApplicationId || !applicationId) return;
            this.$confirm("撤回后可重新提交修改实名认证申请，是否继续？", "确认撤回", {
                type: "warning",
            }).then(() => {
                this.withdrawingModificationApplicationId = applicationId;
                return request.post(API.user.realNameModification.withdrawApplication(applicationId));
            }).then((response) => {
                if (!isResultSuccess(response)) throw getResultError(response, "撤回修改实名认证申请失败");
                this.$message.success("修改实名认证申请已撤回");
                return this.loadModificationApplications();
            }).catch((error) => {
                if (error === "cancel" || error === "close") return;
                this.$message.error(error.message || getResultMessage(error, "撤回修改实名认证申请失败，请稍后重试"));
            }).finally(() => {
                this.withdrawingModificationApplicationId = null;
            });
        },
        modificationStatusTagType(status){
            const tagTypes = {
                PENDING: "warning",
                APPROVED: "success",
                REJECTED: "danger",
                WITHDRAWN: "info",
            };
            return tagTypes[status] || "info";
        },
        retryVerificationLoad(){
            this.loadVerification();
        },
        loadVerification(loadModificationHistory = false){
            this.verificationLoading = true;
            this.verificationLoadError = "";

            return request.get(API.user.realNameVerification.status)
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        throw getResultError(response, "实名认证信息加载失败");
                    }
                    this.verification = realNameCertification.normalizeRealNameStatus(getResultData(response) || {});
                    this.verificationStatusLoaded = true;
                    if (this.verification.status === "APPROVED" && loadModificationHistory) {
                        return this.loadModificationApplications().then(() => true);
                    }
                    if (loadModificationHistory) {
                        this.modificationApplications = [];
                    }
                    return true;
                })
                .catch((error) => {
                    this.verificationStatusLoaded = false;
                    this.verificationLoadError = error.message || getResultMessage(error, "实名认证信息加载失败");
                    return false;
                })
                .finally(() => {
                    this.verificationLoading = false;
                });
        },
        handleIdentityPortraitUpload(file){
            const rawFile = file && file.raw;
            if (!rawFile || !String(rawFile.type || "").startsWith("image/")) {
                this.$message.error("请上传图片文件");
                return;
            }
            if (rawFile.size > 5 * 1024 * 1024) {
                this.$message.error("身份证照片大小不能超过 5MiB");
                return;
            }
            this.clearIdentityPortrait();
            this.clearVerificationToken();
            this.verificationForm.portraitPreview = URL.createObjectURL(rawFile);
            this.verificationForm.portraitFile = rawFile;
        },
        clearIdentityPortrait(){
            const previewUrl = this.verificationForm.portraitPreview;
            if (previewUrl) URL.revokeObjectURL(previewUrl);
            this.verificationForm.portraitPreview = "";
            this.verificationForm.portraitFile = null;
            const uploader = this.$refs.identityPortraitUploader;
            if (uploader) uploader.clearFiles();
        },
        clearVerificationToken(){
            this.verificationForm.recognition.verificationToken = "";
        },
        resetVerificationForm(){
            this.clearIdentityPortrait();
            this.verificationForm = createEmptyVerificationForm();
        },
        buildVerificationFormData(){
            const data = new FormData();
            data.append("idCardPortrait", this.verificationForm.portraitFile);
            return data;
        },
        recognizeIdentityPortrait(){
            if (this.submittingVerification) return;
            if (!this.verificationForm.portraitFile) {
                this.$message.error("请先上传身份证人像面");
                return;
            }
            this.submittingVerification = true;
            request.post(API.user.realNameVerification.recognize, this.buildVerificationFormData())
                .then((response) => {
                    if (!isResultSuccess(response)) throw getResultError(response, "实名认证识别失败");
                    const result = getResultData(response) || {};
                    if (["FAILURE", "RISK"].indexOf(result.outcome) !== -1) {
                        this.clearVerificationToken();
                        this.clearIdentityPortrait();
                        this.$message.warning(result.message || "识别未通过，请重新上传身份证人像面");
                        return;
                    }
                    if (result.outcome !== "SUCCESS") throw new Error("实名认证识别失败，请重新上传");
                    this.verificationForm.recognition = {
                        realNameMasked: realNameCertification.maskRealName(result.realName),
                        idCardMasked: result.idCardMasked || "",
                        verificationToken: result.verificationToken || "",
                    };
                    if (!this.verificationForm.recognition.verificationToken) {
                        throw new Error("核验凭证无效，请重新上传");
                    }
                    this.verificationStep = "REVIEW";
                }).catch((error) => {
                    this.clearVerificationToken();
                    const status = error && error.response && error.response.status;
                    const message = status === 429 ? "今日识别次数已达上限，请次日再试" : (error.message || getResultMessage(error, "实名认证识别失败，请重新上传"));
                    this.$message.error(message);
                }).finally(() => {
                    this.submittingVerification = false;
                });
        },
        startVerificationApplication(){
            this.resetVerificationForm();
            this.verificationStep = "UPLOAD";
            this.showVerificationForm = true;
        },
        confirmVerification(){
            if (this.submittingVerification || !this.verificationForm.agreementAccepted) return;
            const verificationToken = this.verificationForm.recognition.verificationToken;
            if (!verificationToken) {
                this.$message.error("核验凭证已失效，请重新上传");
                this.startVerificationApplication();
                return;
            }
            this.submittingVerification = true;
            request.post(API.user.realNameVerification.confirm, { verificationToken, agreementAccepted: true })
                .then((response) => {
                    if (!isResultSuccess(response)) throw getResultError(response, "实名认证确认失败");
                    this.clearVerificationToken();
                    this.verificationStep = "COMPLETE";
                    return this.loadVerification();
                }).then(() => {
                    this.$router.replace({ name: "creatorIntro" });
                }).catch((error) => {
                    this.clearVerificationToken();
                    this.verificationStep = "UPLOAD";
                    const message = error.message || getResultMessage(error, "核验凭证已失效，请重新上传");
                    if (realNameModification.isIdentityConflict({
                        response: error.response,
                        code: error.code,
                        message,
                    })) {
                        this.$message.error("该身份证已绑定其他账号，请使用原账号处理，或通过账号找回流程恢复原账号后再操作。");
                        return;
                    }
                    this.$message.error(message);
                }).finally(() => {
                    this.submittingVerification = false;
                });
        },
        handleVerificationDialogClosed(){
            this.clearVerificationToken();
            if (this.showVerificationForm) this.resetVerificationForm();
            this.showVerificationForm = false;
        },
        openCampusVerificationDialog(){
            this.showCampusVerificationForm = false;
            this.campusVerificationDialogVisible = true;
            Promise.all([this.loadVerification(), this.loadCampusVerification()]).then(([verificationLoaded, campusLoaded]) => {
                if (verificationLoaded && campusLoaded && this.campusVerification.status === "UNVERIFIED") {
                    this.startCampusVerificationApplication();
                }
            });
        },
        openRealNameVerificationFromRoute(){
            if (this.$route.query.openRealNameVerification !== "1") return;
            const query = { ...this.$route.query };
            delete query.openRealNameVerification;
            this.$router.replace({ name: "basic", query });
            this.openVerificationDialog();
        },
        openCampusVerificationFromRoute(){
            if (this.$route.query.openCampusCertification !== "1") return;
            const query = { ...this.$route.query };
            delete query.openCampusCertification;
            this.$router.replace({ name: "basic", query });
            this.openCampusVerificationDialog();
        },
        retryCampusVerificationLoad(){
            this.loadCampusVerification();
        },
        campusVerificationStatusTextFor(status){
            const texts = {
                UNVERIFIED: "未认证",
                PENDING: "审核中",
                APPROVED: "已认证",
                REJECTED: "已驳回",
                WITHDRAWN: "已撤回",
                EXPIRED: "已到期",
                REVOKED: "已撤销",
                SUSPENDED: "已暂停",
            };
            return texts[status] || texts.UNVERIFIED;
        },
        validateExpectedGraduationMonth(value, callback){
            if (!value) {
                callback();
                return;
            }
            const error = campusCertificationMonth.getExpectedGraduationMonthError(value, this.campusMonthBounds);
            if (error) {
                callback(new Error(error));
                return;
            }
            const enrollmentMonth = this.campusVerificationForm.enrollmentMonth;
            if (enrollmentMonth && value < enrollmentMonth) {
                callback(new Error("预计毕业年月不能早于入学年月"));
                return;
            }
            callback();
        },
        validateCampusGraduationMonth(){
            const form = this.$refs.campusVerificationForm;
            if (form && this.campusVerificationForm.expectedGraduationMonth) {
                form.validateField("expectedGraduationMonth");
            }
        },
        loadCampusVerification(){
            this.campusVerificationLoading = true;
            this.campusVerificationLoadError = "";

            return request.get(API.certifications.campus.overview)
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        throw getResultError(response, "校园认证信息加载失败");
                    }
                    const overview = campusCertification.normalizeCampusOverview(getResultData(response) || {});
                    this.campusVerification = overview.verification;
                    this.campusVerificationHistory = overview.history;
                    this.campusVerificationStatusLoaded = true;
                    return true;
                })
                .catch((error) => {
                    this.campusVerificationStatusLoaded = false;
                    this.campusVerificationLoadError = error.message || getResultMessage(error, "校园认证信息加载失败");
                    return false;
                })
                .finally(() => {
                    this.campusVerificationLoading = false;
                });
        },
        loadCampusSchools(keyword = ""){
            const query = typeof keyword === "string" ? keyword.trim() : "";
            this.campusSchoolsLoading = true;

            return request.get(API.certifications.campus.schools, {
                params: query ? { keyword: query } : {},
            }).then((response) => {
                if (!isResultSuccess(response)) {
                    throw getResultError(response, "院校列表加载失败");
                }
                const schools = Array.isArray(getResultData(response)) ? getResultData(response) : [];
                this.campusSchools = schools
                    .filter((school) => school && school.id !== undefined && school.id !== null && school.name)
                    .map((school) => {
                        const location = [school.provinceName, school.cityName].filter(Boolean).join(" ");
                        return {
                            id: school.id,
                            label: location ? `${school.name}（${location}）` : school.name,
                        };
                    });
            }).catch((error) => {
                this.campusSchools = [];
                this.$message.error(error.message || getResultMessage(error, "院校列表加载失败，请稍后重试"));
            }).finally(() => {
                this.campusSchoolsLoading = false;
            });
        },
        searchCampusSchools(keyword){
            this.loadCampusSchools(keyword);
        },
        startCampusVerificationApplication(){
            if (this.verification.status !== "APPROVED") {
                this.$message.warning(this.campusVerificationEligibilityMessage);
                return;
            }
            this.campusMonthBounds = campusCertificationMonth.getCampusMonthBounds();
            this.resetCampusVerificationForm();
            this.showCampusVerificationForm = true;
            this.loadCampusSchools();
        },
        handleStudentCardCoverUpload(file){
            this.handleStudentCardUpload("cover", file);
        },
        handleStudentCardProfileUpload(file){
            this.handleStudentCardUpload("profile", file);
        },
        async handleStudentCardUpload(side, file){
            const rawFile = file && file.raw;
            if (!rawFile) {
                this.$message.error("请选择学生证图片");
                return;
            }
            if (rawFile.size > 5 * 1024 * 1024) {
                this.$message.error("学生证材料大小不能超过 5MiB");
                return;
            }
            const hasSupportedSignature = await this.hasSupportedStudentCardImageSignature(rawFile);
            if (!hasSupportedSignature) {
                this.$message.error("学生证材料仅支持实际内容为 JPG、PNG 的图片");
                return;
            }
            this.clearStudentCardPreview(side);
            const field = side === "cover" ? "studentCardCover" : "studentCardProfile";
            this.campusVerificationForm[`${field}Preview`] = URL.createObjectURL(rawFile);
            this.campusVerificationForm[field] = true;
            this.campusVerificationForm[`${field}File`] = rawFile;
            const form = this.$refs.campusVerificationForm;
            if (form) form.validateField(field);
        },
        hasSupportedStudentCardImageSignature(file){
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(campusCertification.isSupportedImageSignature(new Uint8Array(reader.result)));
                };
                reader.onerror = () => resolve(false);
                reader.readAsArrayBuffer(file.slice(0, 8));
            });
        },
        clearStudentCardPreview(side){
            const field = side === "cover" ? "studentCardCover" : "studentCardProfile";
            const previewKey = `${field}Preview`;
            const previewUrl = this.campusVerificationForm[previewKey];
            if (previewUrl) URL.revokeObjectURL(previewUrl);
            this.campusVerificationForm[previewKey] = "";
        },
        clearStudentCardImage(side){
            const field = side === "cover" ? "studentCardCover" : "studentCardProfile";
            this.clearStudentCardPreview(side);
            this.campusVerificationForm[field] = false;
            this.campusVerificationForm[`${field}File`] = null;
            const uploader = this.$refs[side === "cover" ? "studentCardCoverUploader" : "studentCardProfileUploader"];
            if (uploader) uploader.clearFiles();
            const form = this.$refs.campusVerificationForm;
            if (form) form.validateField(field);
        },
        resetCampusVerificationForm(){
            this.clearStudentCardPreview("cover");
            this.clearStudentCardPreview("profile");
            this.campusVerificationForm = createEmptyCampusVerificationForm();
            const coverUploader = this.$refs.studentCardCoverUploader;
            const profileUploader = this.$refs.studentCardProfileUploader;
            if (coverUploader) coverUploader.clearFiles();
            if (profileUploader) profileUploader.clearFiles();
            const form = this.$refs.campusVerificationForm;
            if (form) form.clearValidate();
        },
        buildCampusVerificationFormData(){
            const data = new FormData();
            data.append("schoolId", this.campusVerificationForm.schoolId);
            data.append("enrollmentMonth", this.campusVerificationForm.enrollmentMonth);
            data.append("expectedGraduationMonth", this.campusVerificationForm.expectedGraduationMonth);
            data.append("studentCardCover", this.campusVerificationForm.studentCardCoverFile);
            data.append("studentCardProfile", this.campusVerificationForm.studentCardProfileFile);
            return data;
        },
        submitCampusVerification(){
            if (this.submittingCampusVerification) return;
            const form = this.$refs.campusVerificationForm;
            if (!form) return;
            form.validate((valid) => {
                if (!valid) return;
                if (!this.campusVerificationForm.studentCardCoverFile || !this.campusVerificationForm.studentCardProfileFile) {
                    this.$message.error("请重新上传学生证封面和个人信息页");
                    return;
                }
                this.submittingCampusVerification = true;
                request.post(
                    API.certifications.campus.applications,
                    this.buildCampusVerificationFormData(),
                ).then((response) => {
                    if (!isResultSuccess(response)) {
                        throw getResultError(response, "校园认证资料提交失败");
                    }
                    this.resetCampusVerificationForm();
                    this.showCampusVerificationForm = false;
                    this.$message.success("校园认证资料已提交，等待审核");
                    return this.loadCampusVerification();
                }).catch((error) => {
                    this.$message.error(getResultMessage(error, "校园认证资料提交失败，请稍后重试"));
                }).finally(() => {
                    this.submittingCampusVerification = false;
                });
            });
        },
        withdrawCampusVerification(){
            if (this.withdrawingCampusVerification) return;
            const applicationId = this.campusVerification.pendingApplicationId;
            if (!applicationId) return;

            this.$confirm("撤回后可重新提交校园认证资料，是否继续？", "撤回申请", {
                confirmButtonText: "确认撤回",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.withdrawingCampusVerification = true;
                return request.post(API.certifications.campus.withdrawApplication(applicationId));
            }).then((response) => {
                if (!isResultSuccess(response)) {
                    throw getResultError(response, "校园认证申请撤回失败");
                }
                this.$message.success("校园认证申请已撤回");
                return this.loadCampusVerification();
            }).catch((error) => {
                if (error === "cancel" || error === "close") return;
                this.$message.error(error.message || getResultMessage(error, "校园认证申请撤回失败，请稍后重试"));
            }).finally(() => {
                this.withdrawingCampusVerification = false;
            });
        },
        handleCampusVerificationDialogClosed(){
            if (this.showCampusVerificationForm) this.resetCampusVerificationForm();
            this.showCampusVerificationForm = false;
        },
        handleSubmit(){
            if (this.savingProfile) return;
            const version = this.$store.state.user.sessionVersion;
            const epoch = this.requestEpoch;
            const isCurrent = () => version === this.$store.state.user.sessionVersion && epoch === this.requestEpoch;
            this.$refs.basicDataForm.validate((valid) => {
                if (!isCurrent()) return;
                if (!valid) {
                    this.$message.error("请检查基本资料填写");
                    return;
                }
                this.savingProfile = true;
                this.handleChangeBasic({
                    nickname: this.form.nickname,
                    city: this.form.city,
                    address: this.form.address,
                    born: this.form.born,
                    sex: this.form.sex,
                    email: this.form.email,
                    wechat: this.form.wechat,
                    qq: this.form.qq,
                }).then((res) => {
                    if (!isCurrent()) return;
                    if (res.type !== 'success') { this.$message.error(res.msg); return; }
                    this.$message.success(res.msg);
                }).catch(() => { if (isCurrent()) this.$message.error("资料保存失败，请稍后重试"); }).finally(() => { this.savingProfile = false; })
            });
        }
    },
    watch: {
        basic_data: {
            handler: "setForm",
            immediate: true
        },
        basic_data_error(message){
            if (message) {
                this.$message.error(message);
            }
        }
    },
    mounted(){
        if (this.basic_data_error) {
            this.$message.error(this.basic_data_error);
        }
        this.loadVerification(false);
        this.loadCampusVerification();
        this.openRealNameVerificationFromRoute();
        this.openCampusVerificationFromRoute();
    },
    beforeDestroy(){
        this.requestEpoch += 1;
        this.clearVerificationToken();
        this.clearIdentityPortrait();
        this.clearStudentCardPreview("cover");
        this.clearStudentCardPreview("profile");
    },
}
</script>

<style scoped>
/* element-ui */
.basic-data-form>>>.el-form-item__label{
    color: #909399;
}

.basic-data{
    padding: 20px 100px;
}
.basic-data>>>.real-name-verification-dialog{
    overflow: hidden;
    color: #332d49;
    border: 1px solid #d9e9f1;
    border-radius: 20px;
    box-shadow: 0 24px 70px rgba(30, 42, 58, .28);
}
.basic-data>>>.real-name-verification-dialog .el-dialog__header{
    padding: 19px 22px 16px;
    border-bottom: 1px solid #e7eff3;
}
.basic-data>>>.real-name-verification-dialog .el-dialog__title{
    color: #3f3158;
    font-size: 20px;
    font-weight: 700;
}
.basic-data>>>.real-name-verification-dialog .el-dialog__headerbtn{
    top: 18px;
    right: 20px;
}
.basic-data>>>.real-name-verification-dialog .el-dialog__headerbtn .el-dialog__close{
    display: grid;
    width: 30px;
    height: 30px;
    place-items: center;
    color: #5d6070;
    background: #f1f6f8;
    border-radius: 50%;
    font-size: 18px;
}
.basic-data>>>.real-name-verification-dialog .el-dialog__body{
    padding: 22px;
}
.verification-entry{
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    width: 200px;
    height: 28px;
    padding: 3px 10px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    color: #909399;
    font-size: 13px;
    text-align: left;
    transition: border-color .2s, box-shadow .2s;
}
.verification-entry:hover,
.verification-entry:focus{
    border-color: #409EFF;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, .08);
    outline: none;
}
.verification-entry:disabled{
    cursor: wait;
}
.campus-verification-entry.verification-status-approved:hover,
.campus-verification-entry.verification-status-approved:focus{
    border-color: #67C23A;
    box-shadow: 0 0 0 2px rgba(103, 194, 58, .08);
}
.verification-entry > i:first-child{
    margin-right: 7px;
    font-size: 18px;
}
.verification-entry-text{
    font-weight: 600;
    white-space: nowrap;
}
.verification-status-pending{
    color: #E6A23C;
}
.verification-status-expired{
    color: #E6A23C;
}
.verification-status-approved{
    color: #67C23A;
}
.verification-status-rejected{
    color: #F56C6C;
}
.verification-status-revoked{
    color: #F56C6C;
}
.verification-status-suspended{
    color: #F56C6C;
}
.verification-status-withdrawn{
    color: #909399;
}
.verification-status-unverified{
    color: #909399;
}
.verification-load-error{
    display: flex;
    align-items: flex-start;
    padding: 20px;
    border-radius: 6px;
    background: #FEF0F0;
    color: #F56C6C;
}
.verification-load-error > i{
    margin: 3px 8px 0 0;
    font-size: 18px;
}
.verification-load-error p{
    margin: 0 0 10px;
    line-height: 20px;
}
.verification-privacy-note{
    display: flex;
    align-items: flex-start;
    margin-bottom: 22px;
    padding: 10px 12px;
    border-radius: 4px;
    background: #F4F8FF;
    color: #606266;
    font-size: 13px;
    line-height: 20px;
}
.verification-privacy-note i{
    margin: 2px 7px 0 0;
    color: #409EFF;
}
.campus-verification-field-tip{
    margin: 5px 0 0;
    color: #909399;
    font-size: 12px;
    line-height: 18px;
}
.campus-verification-input{
    width: 360px;
}
.verification-application>>>.el-input{
    max-width: 360px;
}
.verification-upload-list{
    display: flex;
    gap: 16px;
}
.verification-upload-item{
    position: relative;
    width: 196px;
    text-align: center;
}
.verification-upload>>>.el-upload{
    display: block;
    width: 196px;
    height: 124px;
    overflow: hidden;
    border: 1px dashed #C0C4CC;
    border-radius: 6px;
    background: #FBFCFE;
}
.verification-upload>>>.el-upload:hover{
    border-color: #409EFF;
}
.verification-upload-preview{
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.verification-upload-empty{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #909399;
    font-size: 13px;
}
.verification-upload-empty i{
    margin-bottom: 8px;
    color: #409EFF;
    font-size: 26px;
}
.verification-upload-item .el-button{
    display: block;
    width: 100%;
    margin: 0;
}
.verification-upload-label{
    margin-top: 3px;
    color: #606266;
    font-size: 12px;
}
.verification-upload-validation{
    margin: 0;
    text-align: left;
}
.verification-upload-validation>>>.el-form-item__content{
    margin-left: 0 !important;
    line-height: 16px;
}
.verification-upload-validation>>>.el-form-item__error{
    position: static;
    padding-top: 0;
}
.verification-upload-tip{
    margin: 8px 0 0;
    color: #909399;
    font-size: 12px;
    line-height: 18px;
}
.automatic-verification{
    max-width: 520px;
    margin: 0 auto;
}
.verification-steps{
    display: flex;
    margin: 0 0 28px;
    padding: 0;
    list-style: none;
}
.verification-steps li{
    position: relative;
    z-index: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #909399;
    font-size: 13px;
}
.verification-steps li:not(:last-child)::after{
    content: "";
    position: absolute;
    z-index: -1;
    top: 14px;
    left: 50%;
    width: 100%;
    height: 2px;
    background: #DCDFE6;
}
.verification-steps li.done:not(:last-child)::after{
    background: #409EFF;
}
.verification-steps span{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    margin-bottom: 8px;
    border-radius: 50%;
    background: #DCDFE6;
    color: #909399;
    font-weight: 600;
}
.verification-steps strong{
    font-weight: 500;
}
.verification-steps .active,
.verification-steps .done{
    color: #409EFF;
}
.verification-steps .active span,
.verification-steps .done span{
    background: #409EFF;
    color: #fff;
}
.portrait-upload{
    width: 196px;
    margin: 0 auto;
}
.portrait-upload + .el-button{
    display: block;
    margin: 4px auto 0;
}
.verification-agreement{
    display: block;
    margin-top: 20px;
    line-height: 20px;
    white-space: normal;
}
.verification-status-panel{
    padding: 2px 8px 8px;
}
.real-name-verification-status-panel{
    padding-bottom: 12px;
}
.real-name-verification-status-panel .verification-status-hero.verification-status-approved{
    padding: 18px 20px;
    border-color: #D5EAFF;
    border-radius: 18px;
    color: #409EFF;
    background: linear-gradient(110deg, #ECF5FF, #F8FCFF);
}
.real-name-verification-status-panel .verification-status-hero.verification-status-approved > i{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-right: 14px;
    border: 2px solid #409EFF;
    border-radius: 50%;
    background: #fff;
    font-size: 22px;
}
.real-name-verification-status-panel .verification-status-hero.verification-status-approved strong{
    color: #303133;
    font-size: 18px;
}
.real-name-verification-status-panel .verification-status-hero.verification-status-approved p{
    color: #7A8798;
}
.verification-unverified-hero{
    padding: 22px;
    border-radius: 14px;
    background: linear-gradient(130deg, #ECF5FF, #FAFCFF);
}
.verification-unverified-kicker{
    margin: 0 0 6px;
    color: #409EFF;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .04em;
}
.verification-unverified-hero h2{
    margin: 0;
    color: #202733;
    font-size: 20px;
    line-height: 28px;
}
.verification-unverified-hero p:not(.verification-unverified-kicker){
    margin: 7px 0 0;
    color: #687487;
    font-size: 13px;
    line-height: 20px;
}
.verification-unverified-benefits{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin: 16px 0;
}
.verification-unverified-benefits > div{
    min-height: 82px;
    padding: 13px;
    border: 1px solid #E9EDF2;
    border-radius: 10px;
    background: #fff;
}
.verification-unverified-benefits strong,
.verification-unverified-benefits span{
    display: block;
}
.verification-unverified-benefits strong{
    color: #303846;
    font-size: 13px;
}
.verification-unverified-benefits span{
    margin-top: 4px;
    color: #7E8795;
    font-size: 12px;
    line-height: 18px;
}
.verification-unverified-steps{
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 18px 0 0;
}
.verification-unverified-steps span{
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #758092;
    font-size: 12px;
}
.verification-unverified-steps b{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    color: #409EFF;
    background: #E3F1FF;
}
.verification-unverified-steps > i{
    width: 18px;
    height: 1px;
    background: #DBE2EB;
}
.verification-unverified-actions{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-top: 16px;
    padding: 15px 18px;
    border-radius: 16px;
    background: #F7F9FB;
}
.verification-unverified-actions p{
    margin: 0;
    color: #677181;
    font-size: 12px;
}
.verification-unverified-actions .el-button{
    flex: 0 0 auto;
    min-height: 34px;
    padding: 0 15px;
    border-radius: 8px;
    font-size: 13px;
}
.real-name-modification-entry{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 16px;
    padding: 14px 18px;
    border-radius: 16px;
    background: #F7FAFF;
}
.real-name-modification-entry p{
    margin: 0 0 6px;
    color: #606266;
    font-size: 12px;
    line-height: 18px;
}
.verification-modification-copy{
    min-width: 0;
}
.verification-modification-copy p:last-child,
.real-name-modification-entry > p:last-child{
    margin-bottom: 0;
}
.verification-modification-actions{
    display: flex;
    flex: 0 0 auto;
    gap: 8px;
}
.verification-modification-actions .el-button{
    margin-left: 0;
    min-height: 34px;
    padding: 0 15px;
    border-radius: 8px;
    font-size: 13px;
}
.real-name-modification-entry > p:last-child{
    flex-basis: 100%;
}
.modification-application-input{
    width: 100%;
}
.modification-application-tip,
.modification-risk-copy{
    margin: 0;
    color: #606266;
    line-height: 22px;
}
.modification-history-drawer{
    padding: 0 20px 20px;
}
.modification-history-item{
    padding: 14px 0;
    border-bottom: 1px solid #EBEEF5;
}
.modification-history-item header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}
.modification-history-item p{
    margin: 8px 0 0;
    color: #606266;
    font-size: 13px;
    line-height: 20px;
    white-space: pre-wrap;
    word-break: break-word;
}
.modification-history-item .modification-history-pending{
    color: #E6A23C;
}
.modification-history-item .modification-history-resolution{
    color: #F56C6C;
}
.modification-history-item .modification-history-time{
    color: #909399;
}
.verification-result{
    display: flex;
    align-items: center;
    min-height: 64px;
    padding: 14px 16px;
    border: 1px solid #EBEEF5;
    border-radius: 6px;
    background: #FAFBFC;
}
.verification-result > i{
    margin-right: 12px;
    font-size: 28px;
}
.verification-result strong{
    font-size: 16px;
}
.verification-result p{
    margin: 5px 0 0;
    color: #909399;
    font-size: 13px;
}
.verification-summary{
    margin-top: 16px;
    padding: 4px 16px;
    border: 1px solid #EBEEF5;
    border-radius: 6px;
}
.real-name-verification-status-panel .verification-status-summary{
    margin-top: 16px;
    padding: 2px 18px;
    border-color: #E5EDF7;
    border-radius: 16px;
}
.real-name-verification-status-panel .verification-status-summary > div{
    min-height: 52px;
    padding: 0;
}
.verification-summary > div{
    display: flex;
    justify-content: space-between;
    padding: 11px 0;
    border-bottom: 1px solid #F2F6FC;
    color: #606266;
    font-size: 13px;
}
.verification-summary > div:last-child{
    border-bottom: 0;
}
.verification-summary strong{
    color: #303133;
    font-weight: 500;
}
.verification-rejection{
    display: flex;
    align-items: flex-start;
    margin-top: 16px;
    padding: 10px 12px;
    border-radius: 4px;
    background: #FEF0F0;
    color: #F56C6C;
    font-size: 13px;
    line-height: 20px;
}
.verification-rejection i{
    margin: 2px 7px 0 0;
}
.verification-resubmit-actions{
    margin-top: 14px;
    text-align: right;
}
.verification-history{
    margin-top: 22px;
}
.verification-history h4{
    margin: 0 0 10px;
    color: #303133;
    font-size: 14px;
}
.verification-history-list{
    border-top: 1px solid #EBEEF5;
}
.campus-verification-history-list{
    height: 280px;
    max-height: 40vh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}
.verification-history-item{
    position: relative;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 12px;
    padding: 12px 88px 12px 4px;
    border-bottom: 1px solid #EBEEF5;
    color: #606266;
    font-size: 12px;
    line-height: 20px;
}
.verification-history-time{
    color: #909399;
}
.verification-history-status{
    display: inline-block;
    min-width: 44px;
    font-weight: 600;
}
.verification-history-status-row{
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 24px;
    margin-bottom: 2px;
}
.verification-history-withdraw{
    position: absolute;
    top: 50%;
    right: 16px;
    padding: 0;
    transform: translateY(-50%);
}
.verification-history-item p{
    margin: 0;
}
.verification-history-reason{
    color: #F56C6C;
}
.verification-history-empty{
    margin: 0;
    padding: 16px 0;
    border-top: 1px solid #EBEEF5;
    color: #909399;
    font-size: 13px;
}
.invite-code-card{
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 560px;
    margin: 12px 0 30px;
    padding: 16px 20px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: #f8faff;
}
.invite-code-label{
    margin-bottom: 8px;
    color: #909399;
    font-size: 13px;
}
.invite-code-card strong{
    color: #303133;
    font-size: 22px;
    letter-spacing: 2px;
}
.invite-code-actions{
    display: flex;
    gap: 8px;
}
.invite-poster-dialog-content{
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 380px;
    padding: 16px;
    background: #fbfaf8;
}
.invite-poster-dialog-content img{
    display: block;
    max-width: 100%;
    max-height: 620px;
    object-fit: contain;
    box-shadow: 0 14px 35px rgba(33, 37, 56, 0.14);
}
.invite-poster-status{
    color: #909399;
    text-align: center;
}
.invite-poster-status i{
    color: #e6a23c;
    font-size: 30px;
}
.invite-poster-status p{
    margin: 12px 0 0;
}
/* 头像 */
.avatar-uploader{
    display: inline-block;
    vertical-align: text-bottom;
    height: 52px;
}
.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader>>>.el-upload:hover {
    border-color: #409EFF;
}
.avatar_box{
    position: relative;
    width: 50px;
    height: 50px;
}
.avatar_box::before{
    display: block;
    content: "";
    padding-top: 100%;
}
.avatar_box>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
}
/* 头像提示 */
.avatar_tips{
    display: inline-block;
    margin-left: 12px;
    line-height: 50px;
    vertical-align: middle;
    color: #C0C4CC;
}
/* 输入框 */
.center_basic_data_setbox{
    width: 200px
}
/* 所在城市组件 */
.center_basic_data_set_city>>>.area-select{
    width: 200px;
    height: 28px;
}
.center_basic_data_set_city>>>.area-selected-trigger{
    padding: 0 20px 0 12px;
}
/* 收款信息标题 */
.basic-receipt-title{
    padding-bottom: 10px;
    border-bottom: 1px solid #E4E7ED;
    font-size: 25px;
    font-weight: bold;
    color: #303133;
}
/* 收款信息列表 */
.basic-receipt-list{
    padding: 20px 0;
    list-style: disc;
}
.basic-receipt-list>li{
    margin-bottom: 18px;
}
.basic-receipt-list-title{
    font-size: 16px;
    font-weight: bold;
    color: #606266;
}
.basic-receipt-list-input + .basic-receipt-list-input{
    margin-top: 10px;
}
.basic-receipt-list-input > label{
    width: 300px;
    color: #909399;
}
/* 上传按钮 */
.give_up_btn{
    width: 100px;
}
</style>

<style>
/* append-to-body 的实名认证弹窗需要使用全局选择器，确保外壳样式能命中。 */
.real-name-verification-dialog{
    overflow: hidden;
    color: #332d49;
    border: 1px solid #d9e9f1;
    border-radius: 20px;
    box-shadow: 0 24px 70px rgba(30, 42, 58, .28);
}
.real-name-verification-dialog .el-dialog__header{
    padding: 19px 22px 16px;
    border-bottom: 1px solid #e7eff3;
}
.real-name-verification-dialog .el-dialog__title{
    color: #3f3158;
    font-size: 20px;
    font-weight: 700;
}
.real-name-verification-dialog .el-dialog__headerbtn{
    top: 18px;
    right: 20px;
}
.real-name-verification-dialog .el-dialog__headerbtn .el-dialog__close{
    display: grid;
    width: 30px;
    height: 30px;
    place-items: center;
    color: #5d6070;
    background: #f1f6f8;
    border-radius: 50%;
    font-size: 18px;
}
.real-name-verification-dialog .el-dialog__body{
    padding: 22px;
}
.real-name-verification-dialog .el-dialog__footer{
    padding: 14px 22px;
    border-top: 1px solid #e7eff3;
}
.real-name-verification-dialog .el-dialog__footer .el-button{
    min-height: 38px;
    padding: 8px 15px;
    color: #5b7382;
    border-color: #c9dce5;
    border-radius: 9px;
    font-size: 12px;
    font-weight: 800;
}
.real-name-verification-dialog .el-dialog__footer .el-button--primary{
    color: #fff;
    background: #4f90ae;
    border-color: #4f90ae;
}
.real-name-verification-dialog .verification-modification-actions .el-button{
    min-height: 34px;
    padding: 0 15px;
    border-radius: 8px;
    font-size: 13px;
}
.real-name-modification-dialog,
.real-name-modification-risk-dialog{
    overflow: hidden;
    border-radius: 20px;
    box-shadow: 0 24px 80px rgba(28, 45, 72, .18);
}
.real-name-modification-dialog .el-dialog__header,
.real-name-modification-risk-dialog .el-dialog__header{
    padding: 22px 28px 18px;
}
.real-name-modification-dialog .el-dialog__title,
.real-name-modification-risk-dialog .el-dialog__title{
    color: #202733;
    font-size: 19px;
    font-weight: 600;
}
.real-name-modification-dialog .el-dialog__headerbtn,
.real-name-modification-risk-dialog .el-dialog__headerbtn{
    top: 21px;
    right: 22px;
}
.real-name-modification-dialog .el-dialog__headerbtn .el-dialog__close,
.real-name-modification-risk-dialog .el-dialog__headerbtn .el-dialog__close{
    color: #8B94A1;
    font-size: 20px;
}
.real-name-modification-dialog .el-dialog__body,
.real-name-modification-risk-dialog .el-dialog__body{
    padding: 2px 28px 20px;
}
.real-name-modification-dialog .el-dialog__footer,
.real-name-modification-risk-dialog .el-dialog__footer{
    padding: 0 28px 24px;
}
.real-name-modification-dialog .el-button,
.real-name-modification-risk-dialog .el-button{
    border-radius: 8px;
}
.real-name-modification-dialog .el-input__inner,
.real-name-modification-dialog .el-textarea__inner{
    border-radius: 10px;
}
</style>

<style scoped>
/* Account redesign: keep existing verification dialog styles isolated. */
.account-profile {
    padding: 0;
}
.profile-title {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 16px;
}
.profile-title h1 {
    font-size: 28px;
    margin: 0;
    font-weight: 700;
}
.profile-title p {
    font-size: 13px;
    color: #777780;
    margin: 0;
}
.profile-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}
.profile-column {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.profile-card {
    background: white;
    padding: 24px;
    border-radius: 24px;
    box-shadow: 0 8px 32px #24213a08;
    box-sizing: border-box;
}
.profile-card header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
}
.profile-icon {
    width: 36px;
    height: 36px;
    background: #f0edfd;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.profile-icon img {
    width: 18px;
    height: 18px;
}
.profile-card h2 {
    font-size: 16px;
    line-height: 20px;
    margin: 0;
    color: #24242a;
}
.profile-card header p,
.profile-card p {
    font-size: 12px;
    line-height: 16px;
    color: #777780;
    margin: 0;
}
.profile-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
    row-gap: 4px;
}
.full-field {
    grid-column: 1/-1;
}
.contact-fields {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px;
}
.account-profile .el-form-item {
    margin-bottom: 0;
    min-width: 0;
}
.account-profile >>> .el-form-item__label {
    font-size: 13px;
    color: #777780;
    line-height: 20px;
    padding: 0 0 4px;
    float: none;
    display: block;
    text-align: left;
}
.account-profile >>> .el-form-item__content {
    line-height: 44px;
}
.account-profile >>> .el-input,
.account-profile >>> .el-date-editor,
.account-profile >>> .area-cascader-wrap {
    width: 100%;
}
.account-profile >>> .el-input__inner,
.account-profile >>> .area-select {
    height: 44px;
    border: 1px solid #e9e9ef;
    background: #fafafc;
    border-radius: 12px;
    color: #24242a;
    width: 100%;
}
.account-profile >>> .area-select {
    line-height: 42px;
    margin: 0;
    box-sizing: border-box;
    min-width: 0;
}
.account-profile >>> .el-radio-group {
    display: flex;
    gap: 10px;
    width: 100%;
}
.account-profile >>> .el-radio.is-bordered {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    margin: 0;
    border: 1px solid #e9e9ef;
    background: #fafafc;
    height: 44px;
    border-radius: 12px;
    padding: 0 8px;
    color: #777780;
}
.account-profile >>> .el-radio.is-checked {
    border-color: #7c6ff0;
    background: #f0edfd;
    color: #6b5dd5;
}
.account-profile >>> .el-radio__input.is-checked .el-radio__inner {
    border-color: #7c6ff0;
    background: #7c6ff0;
}
.account-profile >>> .el-radio__input.is-checked + .el-radio__label {
    color: #6b5dd5;
}
.account-profile .invite-code-card {
    display: flex;
    gap: 16px;
    margin: 0;
}
.account-profile .invite-code-card strong {
    font-size: 20px;
    color: #24242a;
}
.account-profile .invite-code-actions {
    margin-left: auto;
    gap: 8px;
    display: flex;
}
.account-profile .invite-code-actions .el-button {
    margin: 0;
    padding: 10px 12px;
    background: white;
    color: #24242a;
    border: 1px solid #e9e9ef;
    border-radius: 100px;
}
.account-profile .invite-code-actions img {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 6px;
}
.certification-card {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}
.certification-card header {
    margin: 0;
    flex: 1;
}
.certification-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}
.certification-actions > div {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
}
.account-profile .verification-entry {
    border: 0;
    min-height: 28px;
    padding: 4px 10px;
    border-radius: 100px;
    font-size: 12px;
    display: inline-flex;
    gap: 4px;
    align-items: center;
    width: auto;
}
.receipt-card h3 {
    border-top: 1px solid #e9e9ef;
    margin: 4px 0 0;
    padding-top: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 400;
}
.receipt-card h3 img {
    width: 18px;
    height: 18px;
}
.receipt-note {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px !important;
    color: #a2a2ac !important;
}
.receipt-note img {
    width: 14px;
    height: 14px;
}
.profile-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
}
.account-profile .profile-actions .el-button {
    height: 40px;
    border-radius: 100px;
    padding: 0 24px;
    margin: 0;
}
.account-profile .profile-actions .el-button--primary {
    background: #7c6ff0;
    border-color: #7c6ff0;
}
.account-profile >>> .el-input__inner:focus {
    border-color: #7c6ff0;
}
.account-profile button:focus-visible {
    outline: 2px solid #6b5dd5;
    outline-offset: 3px;
}
@media (max-width: 1100px) {
    .profile-grid {
        grid-template-columns: 1fr;
    }
    .profile-title {
        display: block;
    }
    .profile-title p {
        margin-top: 8px;
    }
    .account-profile .invite-code-card {
        flex-wrap: wrap;
    }
}
@media (max-width: 700px) {
    .profile-card {
        padding: 20px;
        border-radius: 20px;
    }
    .profile-title h1 {
        font-size: 24px;
    }
    .contact-fields {
        grid-template-columns: 1fr;
    }
    .account-profile .invite-code-actions {
        margin-left: 0;
    }
    .profile-fields {
        column-gap: 10px;
    }
    .account-profile >>> .el-dialog {
        width: calc(100% - 24px) !important;
    }
    .account-profile >>> .area-select {
        width: 100%;
    }
    .profile-actions {
        justify-content: stretch;
    }
    .profile-actions .el-button {
        flex: 1;
    }
}
</style>
<style scoped>
.account-profile h2 {
    font-weight: 700;
}
.account-profile .invite-code-card > .profile-icon img {
    width: 20px;
    height: 20px;
}
.account-profile .receipt-card h3 img {
    width: 17px;
    height: 17px;
}
.account-profile >>> .el-date-editor .el-input__prefix {
    left: auto;
    right: 10px;
}
.account-profile >>> .el-date-editor .el-input__inner {
    padding-left: 15px;
    padding-right: 36px;
}
.account-profile >>> .el-icon-date {
    background: url("../../assets/images/account/fd9a1.svg") center/17px 17px
        no-repeat;
    width: 17px;
}
.account-profile >>> .el-icon-date:before {
    content: none;
}
.account-profile >>> .el-form-item__label {
    font-weight: 400;
}
.account-profile .invite-code-card > div:not(.invite-code-actions) {
    min-width: 0;
}
.account-profile .invite-code-actions {
    flex-wrap: wrap;
}
@media (max-width: 700px) {
    .account-profile .invite-code-card > div:not(.invite-code-actions) {
        margin-right: auto;
    }
    .account-profile .invite-code-actions {
        width: 100%;
    }
}
</style>
<style scoped>
.account-profile .verification-entry img {
    width: 16px;
    height: 16px;
}
.account-profile .verification-status-approved {
    background: #edf7f0;
    color: #47966c;
}
</style>

<style scoped>
.account-profile >>> .el-radio__inner {
    width: 10px;
    height: 10px;
    border: 0;
    background: transparent url("../../assets/images/account/d64aa.svg")
        center/10px 10px no-repeat;
}
.account-profile >>> .el-radio__input.is-checked .el-radio__inner {
    width: 7px;
    height: 7px;
    border: 0;
    background: transparent url("../../assets/images/account/dbe5f.svg")
        center/7px 7px no-repeat;
}
.account-profile >>> .el-radio__inner:after {
    display: none;
}
.account-profile >>> .area-select .area-select-icon {
    width: 17px;
    height: 17px;
    right: 12px;
    top: 50%;
    margin-top: -8px;
    border: 0;
    background: url("../../assets/images/account/da707.svg") center/17px 17px
        no-repeat;
}
.account-profile >>> .area-select-icon:before,
.account-profile >>> .area-select-icon:after {
    display: none;
}
</style>
